module.exports = __webpack_public_path__ + "static/media/Inter-Medium.46d7404e.woff2";